<div class="main-header">
  <h3 class="title">Component Management Tool</h3>
  <a class="logout" (click)="checkLogout()">Log Out</a>
   <app-main-menu></app-main-menu>
</div>
